import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { InputText } from "primereact/inputtext";
import "react-date-range/dist/styles.css"; // Main CSS file
import "react-date-range/dist/theme/default.css"; // Theme CSS file

import {
  Box,
  Typography,
  Grid,
  MenuItem,
  Button,
  Menu,
  Card,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  TextField,
} from "@mui/material";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import CustomDateRange from "./CustomDateRange";
import "primeicons/primeicons.css";
import axios from "axios";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FilterMatchMode } from "primereact/api";
import { FaSearch } from "react-icons/fa";
import { styled, alpha } from "@mui/material/styles";
import "../assets/css/Datatable.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SwapVertSharpIcon from "@mui/icons-material/SwapVertSharp";

import moment from "moment";
import dayjs, { Dayjs } from "dayjs";
import { Tag } from "primereact/tag";

function History() {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [areFiltersEnabled, setAreFiltersEnabled] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filters, setFilters] = useState(null);
  const [filtersRowData, setFiltersRowData] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);
  const [value, setValue] = useState(dayjs("2022-04-17"));
  const dt = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [frequency, setFrequency] = useState(7);
  const [rowData, setRowData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [sourceName, setSourceName] = useState("");
  const [customdate, setCustomDate] = useState(false);
  const open = Boolean(anchorEl);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [isSortClicked, setIsSortClicked] = useState(false);
  const [customRange, setCustomRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [firstHistoryDataPage, setFirstHistoryDataPage] = useState(0);
const [firstRowDataPage, setFirstRowDataPage] = useState(0);

  // useEffect(() => {
  //   fetchHistoryData(7);
  // }, []);
  const handleClose = () => {
    setCustomDate(!customdate);
  };
  useEffect(() => {
    filterState();
  }, []);

  const filterState = () => {
    setFilters({
      source_name: { value: null, matchMode: "contains" },
      frequency: { value: null, matchMode: "contains" },
      Total_duplicate_count: { value: null, matchMode: "contains" },
      arrival_date: { value: null, matchMode: "contains" },
      Actual_source_table_count: { value: null, matchMode: "contains" },
      arrived_source_table_count: { value: null, matchMode: "contains" },

      global: { value: null, matchMode: "contains" },
    });
    setFiltersRowData({
      source_name: { value: null, matchMode: "contains" },
      source_table: { value: null, matchMode: "contains" },
      frequency: { value: null, matchMode: "contains" },
      expected_time: { value: null, matchMode: "contains" },
      last_arrival_datetime: { value: null, matchMode: "contains" },
      arrival_date: { value: null, matchMode: "contains" },
      data_arrived: { value: null, matchMode: "contains" },
      validated_by: { value: null, matchMode: "contains" },
      duplicate_count: { value: null, matchMode: "contains" },
      arrival_time: { value: null, matchMode: "contains" },

      global: { value: null, matchMode: "contains" },
    });
  };
  useEffect(() => {
    setAreFiltersEnabled(false);
    setFirstHistoryDataPage(0)
    // window.location.reload();
  }, [activeTab]);

  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array to only run on component mount
  useEffect(() => {
    filterState();

    if (frequency !== "Custom Date") {
      fetchHistoryData(frequency);
    }
  }, [frequency]);

  // Function to calculate start and end dates based on selected days
  const getDate = (days) => {
    const today = new Date();
    const endDate = today.toISOString().split("T")[0]; // End date (today)
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - days); // Subtract days from today
    console.log(startDate.toISOString().split("T")[0], "jjjjjjjjjj");
    console.log(endDate, "enddate");

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate,
    };
  };
  const fetchHistoryData = async (days) => {
    const { startDate, endDate } = getDate(days);
    setLoading(true);
    try {
      const response = await axios.get(
        `get-source-table-summary/?start_date=${startDate}&end_date=${endDate}`
      );
      console.log(response, "reeeeeeeeeess");

      const sortedData = response.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setHistoryData(sortedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching history data:", error);
      setLoading(false);
    }
  };

  const handleDaysChange = (event, newDays) => {
    console.log(newDays, event.target.innerText, "value");

    if (newDays !== null && newDays !== "Custom Date") {
      const daysValue = parseInt(newDays.split(" ")[0], 10);
      setFrequency(daysValue); // Set the selected days value
    }
    setActiveTab(0);
    setSourceName();
    setShowDatePicker(false);

    if (event.target.innerText === "Custom Date") {
      setShowDatePicker(!showDatePicker);
      setFrequency(newDays);
    }
  };

  const toggleFilters = () => {
    setAreFiltersEnabled(!areFiltersEnabled);
    setIsFilterClicked(!isFilterClicked);
    filterState();
  };
  const onGlobalFilterChange = (e) => {
    setSearchValue(e.target.value);
    const value = e.target.value;
    let _filters = { ...filters };
    console.log(_filters, "........ffffffffff");
    _filters["global"].value = value;
    setFilters(_filters);
  };
  const onGlobalFilterChangeRowdata = (e) => {
    setSearchValue(e.target.value);
    const value = e.target.value;
    let _filters = { ...filters };
    console.log(_filters, "........ffffffffff");
    _filters["global"].value = value;
    setFiltersRowData(_filters);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsSortClicked(!isSortClicked);
  };

  const handleSelectClose = (columneName) => {
    console.log(columneName, "colummm");
    sortDataBy(columneName);

    setAnchorEl(null);
    setIsSortClicked(!isSortClicked);
  };
  const handleSelect = (columneName) => {
    console.log(columneName, "colummm");
    sortDataByRowData(columneName);

    setAnchorEl(null);
    setIsSortClicked(!isSortClicked);
  };
  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color: "rgb(55, 65, 81)",
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[300],
      }),
    },
  }));
  const HistoryTableHeader = (
    <div
      className="table-header align-items-center"
      style={{ display: "flex" }}
    >
      <span
        className="p-input-icon-left"
        style={{ justifyContent: "flex-start" }}
      >
        {console.log("newbbbbbb", frequency)}

        {!searchValue && <FaSearch className="p-icon" />}
        <InputText
          className="input py-1"
          type="search"
          onInput={onGlobalFilterChange}
          placeholder="Search"
        />
      </span>

      <div
        style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
      >
        <div
          style={{
            alignItems: "center",
          }}
        >
          <Grid item>
            <ToggleButtonGroup
              color="primary"
              size="small"
              value={
                frequency === "Custom Date"
                  ? "Custom Date"
                  : `${frequency} Days`
              }
              exclusive
              onChange={handleDaysChange}
              aria-label="frequency"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "0.5rem",
                marginRight: "1rem",
              }}
            >
              {[
                "7 Days",
                "14 Days",
                "21 Days",
                "30 Days",
                "60 Days",
                "Custom Date",
              ].map((freq) => (
                <ToggleButton
                  key={freq}
                  value={freq}
                  sx={{
                    textTransform: "capitalize",
                    color: "#EAEAE",
                    fontWeight: "400",
                    "&.Mui-selected": {
                      color: "white",
                      fontWeight: "500",
                      backgroundColor: "#0576FC",
                      "&:hover": {
                        backgroundColor: "#0576FC",
                      },
                    },
                  }}
                >
                  {freq}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
            {console.log(showDatePicker, "showww")}
            {showDatePicker && (
              <div style={{ marginTop: "10px" }}>
                <CustomDateRange
                  showDatePicker={showDatePicker}
                  setShowDatePicker={setShowDatePicker}
                  historyData={historyData}
                  setHistoryData={setHistoryData}
                  frequency={frequency}
                  setFrequency={setFrequency}
                />
              </div>
            )}
          </Grid>
        </div>
        <Button
          variant="text"
          className="btn-sm ms-1 py-1 mx-1"
          style={{
            color: isFilterClicked ? "#fff" : "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background: isFilterClicked ? "#0576FC" : "",
          }}
          onClick={toggleFilters}
          startIcon={
            <FilterListIcon
              sx={{
                color: isFilterClicked ? "#fff" : "#0576FC",
                fontSize: "1.2rem",
              }}
            />
          }
        >
          Filter
        </Button>
        <Button
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          className="btn-sm ms-1 py-1 mx-1"
          variant="text"
          style={{
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background: isSortClicked ? "#0576FC" : "",
            color: isSortClicked ? "#fff" : "#333",
          }}
          aria-expanded={open ? "true" : undefined}
          disableElevation
          onClick={handleClick}
          startIcon={
            <SwapVertSharpIcon
              sx={{ color: isSortClicked ? "#fff" : "#0576FC" }}
            />
          }
        >
          Sort
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleSelectClose}
        >
          <MenuItem
            onClick={() => handleSelectClose("source_name")}
            disableRipple
          >
            Source Name
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("frequency")}
            disableRipple
          >
            Frequency
          </MenuItem>

          <MenuItem
            onClick={() => handleSelectClose("arrival_date")}
            disableRipple
          >
            Arrival Date
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("Actual_source_table_count")}
            disableRipple
          >
            Expected Number of Files
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("arrived_source_table_count")}
            disableRipple
          >
            Arrived Number of Files
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("Total_duplicate_count")}
            disableRipple
          >
            Duplicate Count
          </MenuItem>
        </StyledMenu>
      </div>
    </div>
  );
  const dataTableHeader = (
    <div
      className="table-header align-items-center my-3"
      style={{ display: "flex" }}
    >
      <span
        className="p-input-icon-left"
        style={{ justifyContent: "flex-start" }}
      >
        {console.log("newbbbbbb", frequency)}

        {!searchValue && <FaSearch className="p-icon" />}
        <InputText
          className="input py-1"
          type="search"
          onInput={onGlobalFilterChangeRowdata}
          placeholder="Search"
        />
      </span>

      <div
        style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
      >
        <Button
          variant="text"
          className="btn-sm ms-1 py-1"
          style={{
            color: isFilterClicked ? "#fff" : "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background: isFilterClicked ? "#0576FC" : "",
          }}
          onClick={toggleFilters}
          startIcon={
            <FilterListIcon
              sx={{
                color: isFilterClicked ? "#fff" : "#0576FC",
                fontSize: "1.2rem",
              }}
            />
          }
        >
          Filter
        </Button>
        <Button
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          className="btn-sm ms-1 py-1"
          variant="text"
          style={{
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background: isSortClicked ? "#0576FC" : "",
            color: isSortClicked ? "#fff" : "#333",
          }}
          aria-expanded={open ? "true" : undefined}
          disableElevation
          onClick={handleClick}
          startIcon={
            <SwapVertSharpIcon
              sx={{ color: isSortClicked ? "#fff" : "#0576FC" }}
            />
          }
        >
          Sort
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleSelect}
        >
          <MenuItem onClick={() => handleSelect("source_name")} disableRipple>
            Source Name
          </MenuItem>
          <MenuItem onClick={() => handleSelect("source_table")} disableRipple>
            Source Table
          </MenuItem>

          <MenuItem onClick={() => handleSelect("frequency")} disableRipple>
            Frequency
          </MenuItem>
          <MenuItem onClick={() => handleSelect("expected_time")} disableRipple>
            Expected Time
          </MenuItem>
          <MenuItem onClick={() => handleSelect("expected_time")} disableRipple>
            Expected Time
          </MenuItem>
          <MenuItem
            onClick={() => handleSelect("last_arrival_datetime")}
            disableRipple
          >
            Last Arrival Date
          </MenuItem>
          <MenuItem
            onClick={() => handleSelect("duplicate_count")}
            disableRipple
          >
            Duplicate Count
          </MenuItem>
          <MenuItem onClick={() => handleSelect("arrival_date")} disableRipple>
            Arrival Date
          </MenuItem>
          <MenuItem onClick={() => handleSelect("arrival_time")} disableRipple>
            Arrival Time
          </MenuItem>
          <MenuItem onClick={() => handleSelect("data_arrived")} disableRipple>
            Arrival Status
          </MenuItem>
          <MenuItem onClick={() => handleSelect("validated_by")} disableRipple>
            Validated By
          </MenuItem>
        </StyledMenu>
      </div>
    </div>
  );
  const getFrequencyStyle = (value) => {
    switch (value) {
      case "DAILY":
        return {
          background: "#007bff20",
          color: "#007bff",
          padding: "0.2rem 1.5rem",
          borderRadius: "25px",
        };
      case "WEEKLY":
        return {
          backgroundColor: "#28a74520",
          color: "#28a745",
          padding: "0.2rem 1.3rem",
          borderRadius: "25px",
        };
      case "MONTHLY":
        return {
          backgroundColor: "#dffa7c63",
          color: "#dab326",
          padding: "0.2rem 0.5rem",
          borderRadius: "25px",
        };
      case "QUARTERLY":
        return {
          backgroundColor: "#fde5cd",
          color: "#f08a2c",
          padding: "0.2rem 0.5rem",
          borderRadius: "25px",
        };
      default:
        return {
          backgroundColor: "#e4dbee",
          color: "#7339bb",
          padding: "0.2rem 1.1rem",
          borderRadius: "25px",
        };
    }
  };

  // Function to return styled frequency value
  const statusBodyTemplate = (rowData) => {
    const style = getFrequencyStyle(rowData.frequency);
    return <span style={style}>{rowData.frequency}</span>;
  };

  // const sortDataBy = (clmName) => {
  //   const sortedData = [...historyData].sort((a, b) => {
  //     const nameA = a[clmName]?.toString().toLowerCase() || "";
  //     const nameB = b[clmName]?.toString().toLowerCase() || "";

  //     if (nameA < nameB) return sortOrder; // Ascending or descending based on sortOrder
  //     if (nameA > nameB) return -sortOrder;
  //     return 0;
  //   });

  //   setHistoryData(sortedData); // Update the state with sorted data
  //   setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  // };
  const sortDataBy = (clmName) => {
    const sortedData = [...historyData].sort((a, b) => {
      const valueA = a[clmName];
      const valueB = b[clmName];

      // Handle undefined or null values
      const valA = valueA !== undefined && valueA !== null ? valueA : "";
      const valB = valueB !== undefined && valueB !== null ? valueB : "";

      if (typeof valA === "number" && typeof valB === "number") {
        // Numeric comparison
        return (valA - valB) * sortOrder;
      } else {
        // String comparison (convert to lowercase for case-insensitive comparison)
        const nameA = valA.toString().toLowerCase();
        const nameB = valB.toString().toLowerCase();

        if (nameA < nameB) return sortOrder;
        if (nameA > nameB) return -sortOrder;
        return 0;
      }
    });

    setHistoryData(sortedData); // Update the state with sorted data
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  };
  const sortDataByRowData = (clmName) => {
    const sortedData = [...rowData].sort((a, b) => {
      const valueA = a[clmName];
      const valueB = b[clmName];

      // Handle undefined or null values
      const valA = valueA !== undefined && valueA !== null ? valueA : "";
      const valB = valueB !== undefined && valueB !== null ? valueB : "";

      if (typeof valA === "number" && typeof valB === "number") {
        // Numeric comparison
        return (valA - valB) * sortOrder;
      } else {
        // String comparison (convert to lowercase for case-insensitive comparison)
        const nameA = valA.toString().toLowerCase();
        const nameB = valB.toString().toLowerCase();

        if (nameA < nameB) return sortOrder;
        if (nameA > nameB) return -sortOrder;
        return 0;
      }
    });

    setRowData(sortedData); // Update the state with sorted data
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  };

  const fetchRowDetails = async (sourceName, arrivalDate, frequency) => {
    try {
      setSourceName(sourceName);
      const apiUrl = `/get-source-details-history/?source_name=${sourceName}&arrival_date=${arrivalDate}&frequency=${frequency}`;
      const response = await axios.get(apiUrl);
      setRowData(response.data);
      console.log(response?.data, "fffffffffffffff");
    } catch (error) {
      console.error("Error fetching feed details:", error);
    }
  };
  const getFrequencyStyl = (value) => {
    switch (value) {
      case "DAILY":
        return {
          background: "#007bff20",
          color: "#007bff",
          padding: "0.2rem 1.5rem",
          borderRadius: "25px",
        };
      case "WEEKLY":
        return {
          backgroundColor: "#28a74520",
          color: "#28a745",
          padding: "0.2rem 1.3rem",
          borderRadius: "25px",
        };
      case "MONTHLY":
        return {
          backgroundColor: "#dffa7c63",
          color: "#dab326",
          padding: "0.2rem 0.5rem",
          borderRadius: "25px",
        };
      case "QUARTERLY":
        return {
          backgroundColor: "#fde5cd",
          color: "#f08a2c",
          padding: "0.2rem 0.5rem",
          borderRadius: "25px",
        };
      default:
        return {
          backgroundColor: "#e4dbee",
          color: "#7339bb",
          padding: "0.2rem 1.1rem",
          borderRadius: "25px",
        };
    }
  };
  const statusBodyTemplat = (rowData) => {
    const style = getFrequencyStyl(rowData.frequency);
    return <span style={style}>{rowData.frequency}</span>;
  };
  const isValidDate = (value) => {
    const date = new Date(value);
    return !isNaN(date.getTime()); // Check if it's a valid date
  };
  // Custom filter function for date fields
  const customDateFilter = (value, filter) => {
    if (!filter) return true; // Show all when no filter is provided
    if (isValidDate(value)) {
      const formattedDate = formatDate(value);
      return formattedDate.includes(filter); // Compare with the formatted date
    }
    return false; // Not a valid date, no match
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  const handleRowClick = (rowData) => {
    console.log(rowData, "rowdata");
    setFirstHistoryDataPage(0); // Store the current page of historyData
   
    fetchRowDetails(
      rowData?.source_name,
      rowData?.arrival_date,
      rowData?.frequency
    );
    handleTabChange();
  };
  const handleTabChange = () => {
    setActiveTab(1);
  };

  return (
    <div style={{ paddingBottom: "1rem" }}>
      <Card
        elevation={0}
        sx={{
          // padding:"0 9px",
          // marginTop: "1rem",
          marginBottom: "0rem",
          borderRadius: "12px",
          background: "none",
        }}
      >
        <div id="frequency_selector" style={{ display: "flex" }}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between "
            // spacing={1}
            // sx={{ marginBottom: "1rem" }}
          >
            <Grid item>
              {sourceName && (
                <div style={{ display: "flex" }}>
                  <Button
                    style={{
                      border: "none",
                      borderRadius: "30px",
                      minWidth: "0",
                    }}
                    onClick={() => {
                      setActiveTab(0);
                      setFirstHistoryDataPage(0);

                      setSourceName();
                    }}
                  >
                    <ArrowBackIcon sx={{ fontSize: "23px", color: "black" }} />
                  </Button>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: "450",
                      padding: "6px 4px",
                      fontSize: "1.2rem",
                    }}
                  >
                    {sourceName}
                  </Typography>
                </div>
              )}
            </Grid>
          </Grid>
        
        </div>
        <div></div>
      </Card>
      <Card sx={{ borderRadius: "12px", boxShadow: 0 }}>
        {activeTab === 0 ? (
          <DataTable
            value={historyData}
            editable
            sortable
            paginator
            first={firstHistoryDataPage} 
            onPage={(e) => setFirstHistoryDataPage(e.first)}
            onRowClick={(e) => handleRowClick(e.data)}
            rows={10}
            style={{ cursor: "pointer", borderRadius: "12px" }}
            resizableColumns
            className={
              areFiltersEnabled
                ? "p-datatable-striped filters-enabled custom-data-table px-4"
                : "p-datatable-striped filters-disabled custom-data-table px-4"
            }
            header={HistoryTableHeader}
            filters={filters}
            onFilter={(e) => setFilters(e.filters)} // Update filters on user input
            filterDisplay="row"
            paginatorLeft={`Total Records: ${historyData?.length}`}
            globalFilterFields={[
              "source_name",
              "frequency",
              "Actual_source_table_count",
              "arrival_date",
              "arrived_source_table_count",
              "Total_duplicate_count",
            ]}
            emptyMessage={
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  height: "1.5rem",
                  marginTop: "0.5rem",
                }}
              >
                No Records Available
              </div>
            }
          >
            <Column
              field="source_name"
              header="Source Name"
              style={{ width: "20%" }}
              // headerStyle={{paddingLeft:"20px"}}
              filter
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Source Name"
            />

            <Column
              field="frequency"
              header="Frequency"
              filter
              body={statusBodyTemplat}
              headerStyle={{ textTransform: "none", paddingLeft: "20px" }}
              style={{ width: "18%", textTransform: "uppercase" }}
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by frequency"
            />
            <Column
              field="arrival_date"
              header="Arrival Date"
              filter
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Arrival Date"
              // body={(rowData) => {
              //   const arrivalDate = new Date(rowData.arrival_date);
              //   const day = String(arrivalDate.getDate()).padStart(2, '0'); // Get day and ensure 2 digits
              //   const month = String(arrivalDate.getMonth() + 1).padStart(2, '0'); // Get month and ensure 2 digits
              //   const year = arrivalDate.getFullYear(); // Get year
              //   return `${day}-${month}-${year}`; // Return formatted date as dd-mm-yyyy
              // }}
              headerStyle={{ textAlign: "center" }}
              style={{ textAlign: "center" }}
            />

            <Column
              field="Actual_source_table_count"
              header="Expected Number of Files"
              style={{ textAlign: "center", width: "20%" }}
              headerStyle={{ paddingLeft: "30px" }}
              filter
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Expected Number of Files"
            />
            <Column
              field="arrived_source_table_count"
              header="Arrived Number of Files"
              body={(rowData) => (
                <span
                  style={{
                    color:
                      rowData.arrived_source_table_count <
                      rowData.Actual_source_table_count
                        ? "red"
                        : "#18a518",
                  }}
                >
                  {rowData.arrived_source_table_count}
                </span>
              )}
              filter
              style={{ textAlign: "center" }}
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Arrived Number of Files"
            />
            <Column
              field="Total_duplicate_count"
              header="Duplicate Count"
              style={{ textAlign: "center", width: "15%" }}
              filter
              filterMenuStyle={{ textAlign: "center" }}
              filterPlaceholder="Search by Duplicate count"
              body={(rowData) => (
                <span
                  style={{
                    color:
                      rowData.Total_duplicate_count === 0 ? "black" : "red",
                  }}
                >
                  {rowData.Total_duplicate_count === 0
                    ? "-"
                    : rowData.Total_duplicate_count}
                </span>
              )}
            />
          </DataTable>
        ) : (
          <>
            <DataTable
             
              value={rowData}
              editable
              first={firstHistoryDataPage} 
              sortable
              paginator
              onPage={(e) => setFirstHistoryDataPage(e.first)}
              // onRowClick={(e) => handleRowClick(e.data)}
              rows={10}
              resizableColumns
              className={
                areFiltersEnabled
                  ? "p-datatable-striped filters-enabled custom-data-table px-4"
                  : "p-datatable-striped filters-disabled custom-data-table px-4"
              }
              header={dataTableHeader}
              filters={filtersRowData}
              filterDisplay="row"
              paginatorLeft={`Total Records: ${rowData?.length}`}
              globalFilterFields={[
                "source_name",
                "source_table",
                "frequency",
                "expected_time",
                "last_arrival_datetime",
                "duplicate_count",
                "arrival_date",
                "data_arrived",
                "validated_by",
              ]}
              emptyMessage={
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    height: "1.5rem",
                    marginTop: "0.5rem",
                  }}
                >
                  No Records Available
                </div>
              }
            >
              <Column
                field="source_name"
                header="Source Name"
                filter
                filterMenuStyle={{ minWidth: "12rem", textAlign: "center" }}
                filterPlaceholder="Search by Source name"
              />
              <Column
                field="source_table"
                header="Source Table"
                filter
                style={{
                  maxWidth: "100px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                body={(rowData) => (
                  <span
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip title={rowData.source_table}>
                      {rowData.source_table}
                    </Tooltip>
                  </span>
                )}
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by Source Table"
              />
              <Column
                field="frequency"
                header="Frequency"
                filter
                style={{ textTransform: "uppercase" }}
                headerStyle={{ textTransform: "none", paddingLeft: "20px" }}
                body={statusBodyTemplate}
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by frequency"
              />
              <Column
                field="expected_time"
                header="Expected By"
                filter
                style={{
                  // maxWidth: "100px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                body={(rowData) => (
                  <span
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip title={rowData.expected_time}>
                      {rowData.expected_time}
                    </Tooltip>
                  </span>
                )}
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by Expected Time"
              />
              <Column
                field="last_arrival_datetime"
                header="Last Arrival Date"
                // body={(rowData) => {
                //     const value = rowData.last_arrival_datetime;
                //     return isValidDate(value) ? formatDate(value) : value; // Format only if it's a valid date
                // }}
                filter
                filterFunction={customDateFilter}
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by last Arrival Date"
              />
              <Column
                field="duplicate_count"
                header="Duplicate Count"
                style={{ textAlign: "center" }}
                filter
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by Duplicate count"
                body={(rowData) => (
                  <span
                    style={{
                      color: rowData.duplicate_count === 0 ? "black" : "red",
                    }}
                  >
                    {rowData.duplicate_count === 0
                      ? "-"
                      : rowData.duplicate_count}
                  </span>
                )}
              />

              <Column
                field="arrival_date"
                header="Arrival Date"
                filter
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by Arrival Date"
                // body={(rowData) => {
                //   const arrivalDate = new Date(rowData.arrival_date);
                //   const day = String(arrivalDate.getDate()).padStart(2, '0'); // Get day and ensure 2 digits
                //   const month = String(arrivalDate.getMonth() + 1).padStart(2, '0'); // Get month and ensure 2 digits
                //   const year = arrivalDate.getFullYear(); // Get year
                //   return `${day}-${month}-${year}`; // Return formatted date as dd-mm-yyyy
                // }}
                headerStyle={{ textAlign: "center" }}
                style={{ textAlign: "center" }}
              />

              <Column
                field="arrival_time"
                header="Arrival Time"
                filter
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by Arrival Time"
              />
              <Column
                field="data_arrived"
                header="Arrival Status"
                body={(rowData) => (
                  <span
                    style={{
                      color:
                        rowData.data_arrived === "ARRIVED LATE" ? "red" : "",
                    }}
                  >
                    {rowData?.data_arrived}
                  </span>
                )}
                filter
                filterMenuStyle={{ minWidth: "12rem", textAlign: "center" }}
                filterPlaceholder="Search by arrival status"
              />
              <Column
                field="validated_by"
                header="Validated By"
                filter
                body={(rowData) => rowData.validated_by}
                filterMenuStyle={{ minWidth: "8rem", textAlign: "center" }}
                filterPlaceholder="Search by validated By"
              />
            </DataTable>
          </>
        )}
      </Card>
    </div>
  );
}

export default History;
